module.exports = __webpack_public_path__ + "media/images/euro _1-fe82e888b3c4296f399566e9fbca14eb.svg";